import {InvListElementType, InvListMapType, InvSearchParamType} from "../interface";
import useGoToNavigation from "../../../../../util/useGotoNavigation";
import EmptyTableRow from "../../../../common/EmptyTableRow";
import {PaginationMain} from "../../../../../components/common/pagination/PaginationMain";
import {useState} from "react";
import {useModal} from "../../../../../hooks";
import {useExportInvExcel} from "../hooks/useExportInvExcel";
import {useDeleteInv} from "../hooks/useDeleteInv";
import {Tooltip} from "react-tooltip";
import DisplayNumber from "../../../../../components/common/number/DisplayNumber";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";

interface PropsType {
    inv: InvListMapType,
    searchParam: InvSearchParamType
}

export default function List({inv, searchParam}: PropsType) {
    const {goToNavigation} = useGoToNavigation();
    const {handleModal} = useModal();

    const [checkedElements, setCheckedElements] = useState<number[]>([])

    const isAllCheck = inv.inventoryList.length !== 0 && inv.inventoryList
        .map(el => el.inventoryId)
        .every(el => checkedElements.includes(el));

    const {mutate: mutateExportInvExcel} = useExportInvExcel()
    const {mutate: mutateDeleteInv} = useDeleteInv()

    const btnExportExcel = () => {
        mutateExportInvExcel({...searchParam, pageNo: 1, limit: 1000000})
    }

    const btnCreateInv = () => {
        goToNavigation("inventory/inv/create", {}, false)
    }

    const btnDelete = () => {
        if (checkedElements.length === 0) {
            handleModal({
                isOpen: true,
                contents: "삭제할 재고를 선택해주세요.",
                type: "alert",
            });
        } else {
            handleModal({
                isOpen: true,
                contents: "삭제하시겠습니까?",
                type: "confirm",
                callback: () => mutateDeleteInv({inventoryIdList: checkedElements})
            });
        }
    }
    /* 내부수정: 새창으로 열리기
    const clickRow = (el: InvListElementType) => {
        el.inventoryId && goToNavigation(`inventory/inv/detail/${el.inventoryId}`, {}, false)
    } */
    const clickRow = (el: InvListElementType, e: React.MouseEvent) => {
        if (!el.inventoryId) return;
        const url = `inventory/inv/detail/${el.inventoryId}`;
        // 휠 클릭
        if (e.button === 1) {
            goToNavigation(url, {}, false, { newTab: true });
            return;
        }
        // ctrl / cmd
        if (e.ctrlKey || e.metaKey) {
            goToNavigation(url, {}, false, { newTab: true });
            return;
        }
        // 일반 클릭
        if (e.button === 0) {
            goToNavigation(url, {}, false);
        }
    };

    const clickAllCheck = () => {
        const inventoryIdList = inv.inventoryList.map(el => el.inventoryId)

        if (isAllCheck) {
            const list = checkedElements.filter(el => !inventoryIdList.includes(el))

            setCheckedElements(list)
        } else {
            // @ts-ignore
            const list = [...new Set([...checkedElements, ...inventoryIdList])]

            setCheckedElements(list)
        }
    }

    const clickCheck = (i: number) => {
        if (checkedElements.includes(i)) {
            const list = checkedElements.filter(el => el !== i)

            setCheckedElements(list)
        } else {
            setCheckedElements([...checkedElements, i])
        }
    }

    return <div className="content_wrap">
        <div className="table_top">
            <h6 className="table_stats">재고 목록(<span>{inv.totalCount}</span>건)</h6>
            <div className="table_toolbar">
                <button className="btn btn-dark w-150px px-0" onClick={btnExportExcel}><img
                    src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"} alt=""/>엑셀 내보내기
                </button>
                <AuthorityChecker authorityNames={['inventoryWriteYn']}>
                    <button className="btn btn-primary w-100px px-0 ms-40px" onClick={btnCreateInv}>재고 생성</button>
                    <button className="btn btn-outline-dark" onClick={btnDelete}><img
                        src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"} alt=""/>선택삭제
                    </button>
                </AuthorityChecker>
            </div>
        </div>
        {/* 내부수정: table_scroll 삭제 */}
        <table
            className="table table-bordered my_table"
            style={{tableLayout: "fixed", width: "100%"}}
        >
            <thead>
            <tr>
                <AuthorityChecker authorityNames={['inventoryWriteYn']}>
                    <th style={{width: "40px"}}>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            checked={isAllCheck}
                            onClick={clickAllCheck}
                        />
                    </th>
                </AuthorityChecker>
                {/* 내부수정: 컬럼 사이즈 조절, 제품군 추가*/}
                <th style={{width: "90px"}}>벤더</th>
                <th style={{width: "90px"}}>카테고리</th>
                <th style={{width: "90px"}}>제품군</th>
                <th style={{
                    width: "400px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                }}>품목
                </th>
                <th style={{
                    width: "160px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                }}>규격
                </th>
                <th style={{width: "100px"}}>대분류</th>
                <th style={{width: "100px"}}>중분류</th>
                <th style={{width: "70px"}}>단위</th>
                <th style={{width: "70px"}}>재고</th>
            </tr>
            </thead>
            {/* 내부수정:  <tr className="clickable" key={idx} onClick={() => clickRow(el)}> */}
            <tbody>
            {inv.inventoryList.length !== 0 ? inv.inventoryList.map((el, idx) => (
                <tr className={checkedElements.includes(el.inventoryId) ? "clickable lightblue" : "clickable"} key={idx} onMouseDown={(e) => clickRow(el, e)}>
                    <AuthorityChecker authorityNames={['inventoryWriteYn']}>
                        <td
                            className="text-center"
                            onMouseDown={(e) => e.stopPropagation()}
                        >
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={checkedElements.includes(el.inventoryId)}
                                onClick={() => clickCheck(el.inventoryId)}
                            />
                        </td>
                    </AuthorityChecker>
                    <td className="text-center">{el.vendor}</td>
                    <td className="text-center">{el.category}</td>
                    <td className="text-center">{el.productRange}</td>
                    <td
                        className="text-center"
                        data-tooltip-id="tooltip-nm"
                        data-tooltip-content={el.new_txt_nm_item}
                        style={{
                            width: "280px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        }}
                    >
                        {el.new_txt_nm_item}
                    </td>
                    <td
                        className="text-center"
                        data-tooltip-id="tooltip-std"
                        data-tooltip-content={el.new_txt_stnd_item}
                        style={{
                            width: "260px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        }}
                    >
                        {el.new_txt_stnd_item}
                    </td>
                    <td className="text-center">{el.majorCategory}</td>
                    <td className="text-center">{el.subCategory}</td>
                    <td className="text-center">{el.inventoryUnit}</td>
                    <td className="text-center"><DisplayNumber value={el.inventoryAmount}/></td>
                </tr>
            )) : <EmptyTableRow colSpan={9}/>}
            </tbody>

            {/* 툴팁은 tbody 밖에 위치해야 흔들림 없음 */}
            <Tooltip id="tooltip-nm" className="custom-tooltip"/>
            <Tooltip id="tooltip-std" className="custom-tooltip"/>
        </table>
        

        <PaginationMain totalCount={inv.totalCount ?? 0}/>
    </div>
}